// Formatadores usados no detalhe da empresa (pagina e painel ao lado da lista).

export const formatPhone = (phones) => {
  if (!phones || !phones.length) return ''
  const tel = `${phones[0].ddd}${phones[0].number}`
  if (tel.length === 11) return tel.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  return tel.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
}

// Percentual com decimais e virgula, como o app mobile mostrava (ex.: 97,5%).
export const formatPercent = (value) => `${String(Number(value) || 0).replace('.', ',')}%`

export const formatHour = (value) => (value ? value.substring(0, 5) : '00:00')

export const detailsPath = (company) => `/companies/details/${company.sourceId}/${company.id}`

const average = (values) => (values.length ? values.reduce((sum, v) => sum + v, 0) / values.length : 0)

// Medias publicas a partir das avaliacoes (rota publica de pesquisa de satisfacao).
// A rota companycounters/by-company e so da propria oficina logada (AB#23690):
// chamar sem login devolvia 401 e o app mandava o visitante para o login.
export function surveyMetrics(evaluations) {
  const list = Array.isArray(evaluations) ? evaluations : []
  const numbers = (key) => list.map(e => Number(e[key])).filter(n => Number.isFinite(n) && n > 0)
  const recommended = list.filter(e => e.Would_Indicate === true || e.Would_Indicate === 1).length
  return {
    ratingRecommendation: list.length ? Math.round((recommended / list.length) * 1000) / 10 : 0,
    ratingPrice: average(numbers('Rating_Price')),
    ratingProductService: average(numbers('Rating_Product_Service')),
  }
}
